import { getCutoffTime, getDayOfWeek } from './deliveryDates';
import { getDeliveryTimeOptions } from './deliveryTime';

const LOCK_LENIENCY_MS = 20 * 60 * 1000; // matches useLockStatus

export const isDateLocked = (date) => {
    const lockDate = getCutoffTime(date);
    return Boolean(lockDate) && Date.now() >= lockDate.getTime() + LOCK_LENIENCY_MS;
};

const isPlanned = (order) => order.isOrdered && order.quantity > 0;

// Meal plan delivery dates whose weekday the zip has slots for in the delivery fee table
export const getMoveTargets = ({ fromDate, deliveryDates, deliveryStatusState, deliveryFees, zipCode }) =>
    deliveryDates
        .filter(date => date === fromDate || (!isDateLocked(date) && !deliveryStatusState[date]?.isSkipped))
        .map(date => ({ date, times: getDeliveryTimeOptions(deliveryFees, getDayOfWeek(date).toLowerCase(), zipCode) }))
        .filter(target => target.times.length > 0);

// Menu dishes swap with the target's unplanned card so neither date loses or duplicates one
export const moveOrdersBetweenDates = ({ fromOrders, toOrders, toDate, deliveryTime }) => {
    const moving = fromOrders.filter(isPlanned);
    const nextFrom = fromOrders.filter(order => !isPlanned(order));
    const nextTo = toOrders.map(order => (isPlanned(order) ? { ...order, deliveryTime } : order));

    moving.forEach(order => {
        const sameDish = (o) => o.dishId === order.dishId && o.meal === order.meal;
        const isMenuDish = toOrders.some(o => o.isCore && sameDish(o));
        const moved = { ...order, deliveryDate: toDate, deliveryTime };

        const openSlot = nextTo.findIndex(o => o.isCore && !o.isOrdered && sameDish(o));
        if (openSlot !== -1) {
            nextTo[openSlot] = { ...moved, isCore: true };
        } else {
            nextTo.push({ ...moved, isCore: isMenuDish ? false : order.isCore });
        }

        if (order.isCore && isMenuDish && !nextFrom.some(o => o.isCore && sameDish(o))) {
            nextFrom.push({
                ...order,
                recordId: `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
                quantity: 0,
                isOrdered: false,
                finalIngredients: order.originalIngredients,
                deliveryTime: undefined,
                autoSubstitutions: [],
                hasUnsavedChange: false,
            });
        }
    });

    return { nextFrom, nextTo, movedCount: moving.length };
};
